import { IUserSessionFormValues } from 'src/types'

export function createFormData(item: NonNullable<IUserSessionFormValues>) {
  return [
    { field: 'X-Forwarded-For', value: item.ip_address || '-' },
    { field: 'Accept-Language', value: item.accept_language || '-' },
    { field: 'User-Agent', value: item.user_agent || '-' },
    { field: 'Cf-Ipcountry', value: item.ip_country || '-' },
  ]
}
